export default __webpack_public_path__ + "static/media/bench-window-back-trapezoid-back.d69b4385.webp";